export const EMPLOYEE_CORE_FIELDS = [
  {
    group: 'identity',
    fields: ['employee_id', 'first_name', 'last_name', 'driver_id', 'status'],
  },
  {
    group: 'employment',
    fields: ['terminal_id', 'staffing_type', 'role', 'hire_date'],
  },
  {
    group: 'contact',
    fields: ['email', 'phone', 'address_line1', 'address_city', 'address_state', 'address_zip'],
  },
  {
    group: 'compliance',
    fields: ['dob', 'dl_number', 'emergency_contact_name', 'emergency_contact_phone'],
  },
  {
    group: 'compensation',
    fields: ['pay_rate_type', 'pay_rate', 'per_diem_rate'],
  },
];
